import { useModal } from 'Hooks/useModal';
import { useStores } from 'Hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ReportModalAction, ReportModalValue } from './ReportModals.types';
import CommonModal from 'PhishingManager/components/Modal';
import ModalHeader from './ModalHeader';

const PATH = 'reports.tabs.saved.deleteReportModal';

function DeleteReportModal() {
	const { t } = useTranslation();
	const { modal, hideModal, setToastInfo } = useModal();
	const { reportsStore } = useStores();

	const modalValue = modal as ReportModalValue;

	if (!modalValue || modalValue.name !== ReportModalAction.Delete) {
		return null;
	}

	const onSubmit = async () => {
		try {
			await reportsStore.deleteReport({
				reportId: modalValue.value.id
			});
			hideModal();
			setToastInfo({ type: "success", message: t(`${PATH}.successNotification`) })
		} catch (e) {
			setToastInfo({ type: "warning", message: t(`errorCodes.genericErrorMessage`) })
		}
	};

	return (
		<CommonModal
			visible
			modalTitle={<ModalHeader title={t('delete')} desc={modalValue.value.name} />}
			confirmText={t('delete')}
			cancelText={t('cancel')}
			iconType={null}
			showConfirmBtn={true}
			onClose={hideModal}
			onConfirm={onSubmit}
			parentClass='report-modal'
			modalContentDesc={[t(`${PATH}.description`)]} />
	);
}

export default observer(DeleteReportModal)
